import { render, staticRenderFns } from "./Treshold.vue?vue&type=template&id=4323bb24&"
import script from "./Treshold.vue?vue&type=script&lang=js&"
export * from "./Treshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports